   const baseURL = "https://api.speedtouchgold.com";
// const baseURL = "https://speedtouch-backend.onrender.com";
export default baseURL;
